import DescriptionStep from '@/profile-creation-wizard/components/for-completion/ui/5_description/DescriptionStep.vue';
import RecommendationStep from '@/profile-creation-wizard/components/for-completion/ui/6_recommendation/RecommendationStep.vue';
import PrivacyStep from '@/profile-creation-wizard/components/for-completion/ui/7_privacy/PrivacyStep.vue';
import HeadlineStep from '@/profile-creation-wizard/components/for-creation/ui/1_headline/HeadlineStep.vue';
import CategorizationStep from '@/profile-creation-wizard/components/for-creation/ui/2_categorization/CategorizationStep.vue';
import MaltClassicExpertiseStep from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/MaltClassicExpertiseStep.vue';
import LocalisationStep from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/LocalisationStep.vue';
import DailyRateStep from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/DailyRateStep.vue';
import {
    CreationStepName,
    MaltClassicStepTrackingName,
    ProfileCreationStepGroup,
    ProfileCreationSteps,
} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import YourEducationStep from '@/profile-creation-wizard/components/for-completion/ui/your-education/YourEducationStep.vue';
import LinkedInImportStep from '@/profile-creation-wizard/components/for-completion/ui/linkedin-import/LinkedInImportStep.vue';
import YourExperienceStep from '@/profile-creation-wizard/components/for-completion/ui/your-experience/YourExperienceStep.vue';
import {MaltClassicCreationStepRoute} from '@/profile-creation-wizard/config/steps/ProfileCreationRoutes';
import AccountCreation from '@/profile-creation-wizard/components/for-creation/ui/5_accountCreation/AccountCreation.vue';

export enum MaltClassicCreationStepNumber {
    SIGNUP_HEADLINE = 1,
    SIGNUP_CATEGORIZATION,
    SIGNUP_EXPERTISE,
    SIGNUP_DAILY_RATE,
    SIGNUP_LOCALISATION,
    SIGNUP_ACCOUNT_CREATION,
    COMPLETION_LINKEDIN,
    COMPLETION_EXPERIENCE,
    COMPLETION_EDUCATION,
    COMPLETION_DESCRIPTION,
    COMPLETION_RECOMMENDATION,
    COMPLETION_PRIVACY,
}

export function maltClassicCreationSteps(withAccountCreation: boolean): ProfileCreationSteps {
    const totalStep = withAccountCreation ? 12 : 11;

    function decrementIfNeeded(stepNumber: number): number {
        if (withAccountCreation) {
            return stepNumber - 1;
        }
        return stepNumber;
    }

    return [
        {
            name: CreationStepName.SIGNUP_HEADLINE,
            route: MaltClassicCreationStepRoute.SIGNUP_HEADLINE,
            stepNumber: MaltClassicCreationStepNumber.SIGNUP_HEADLINE,
            stepCount: totalStep,
            previousStepName: null,
            nextStepName: CreationStepName.SIGNUP_CATEGORIZATION,
            group: ProfileCreationStepGroup.SIGNUP,
            component: HeadlineStep,
            trackingName: MaltClassicStepTrackingName.SIGNUP_HEADLINE,
        },
        {
            name: CreationStepName.SIGNUP_CATEGORIZATION,
            route: MaltClassicCreationStepRoute.SIGNUP_CATEGORIZATION,
            stepNumber: MaltClassicCreationStepNumber.SIGNUP_CATEGORIZATION,
            stepCount: totalStep,
            previousStepName: CreationStepName.SIGNUP_HEADLINE,
            nextStepName: CreationStepName.SIGNUP_EXPERTISE,
            group: ProfileCreationStepGroup.SIGNUP,
            component: CategorizationStep,
            trackingName: MaltClassicStepTrackingName.SIGNUP_CATEGORIZATION,
        },
        {
            name: CreationStepName.SIGNUP_EXPERTISE,
            route: MaltClassicCreationStepRoute.SIGNUP_EXPERTISE,
            stepNumber: MaltClassicCreationStepNumber.SIGNUP_EXPERTISE,
            stepCount: totalStep,
            previousStepName: CreationStepName.SIGNUP_CATEGORIZATION,
            nextStepName: CreationStepName.SIGNUP_DAILY_RATE,
            group: ProfileCreationStepGroup.SIGNUP,
            component: MaltClassicExpertiseStep,
            trackingName: MaltClassicStepTrackingName.SIGNUP_EXPERTISE,
        },
        {
            name: CreationStepName.SIGNUP_DAILY_RATE,
            route: MaltClassicCreationStepRoute.SIGNUP_DAILY_RATE,
            stepNumber: MaltClassicCreationStepNumber.SIGNUP_DAILY_RATE,
            stepCount: totalStep,
            previousStepName: CreationStepName.SIGNUP_EXPERTISE,
            nextStepName: CreationStepName.SIGNUP_LOCALISATION,
            group: ProfileCreationStepGroup.SIGNUP,
            component: DailyRateStep,
            trackingName: MaltClassicStepTrackingName.SIGNUP_DAILY_RATE,
        },
        {
            name: CreationStepName.SIGNUP_LOCALISATION,
            route: MaltClassicCreationStepRoute.SIGNUP_LOCALISATION,
            stepNumber: MaltClassicCreationStepNumber.SIGNUP_LOCALISATION,
            stepCount: totalStep,
            previousStepName: CreationStepName.SIGNUP_DAILY_RATE,
            nextStepName: withAccountCreation ? CreationStepName.SIGNUP_ACCOUNT_CREATION : CreationStepName.COMPLETION_LINKEDIN,
            group: ProfileCreationStepGroup.SIGNUP,
            component: LocalisationStep,
            trackingName: MaltClassicStepTrackingName.SIGNUP_LOCALISATION,
        },
        withAccountCreation
            ? {
                  name: CreationStepName.SIGNUP_ACCOUNT_CREATION,
                  route: MaltClassicCreationStepRoute.SIGNUP_ACCOUNT_CREATION,
                  stepNumber: MaltClassicCreationStepNumber.SIGNUP_ACCOUNT_CREATION,
                  stepCount: totalStep,
                  previousStepName: CreationStepName.SIGNUP_LOCALISATION,
                  nextStepName: CreationStepName.COMPLETION_LINKEDIN,
                  group: ProfileCreationStepGroup.SIGNUP,
                  component: AccountCreation,
                  trackingName: MaltClassicStepTrackingName.SIGNUP_ACCOUNT_CREATION,
              }
            : null,
        // Completion
        {
            name: CreationStepName.COMPLETION_LINKEDIN,
            route: MaltClassicCreationStepRoute.COMPLETION_LINKEDIN,
            stepNumber: decrementIfNeeded(MaltClassicCreationStepNumber.COMPLETION_LINKEDIN),
            stepCount: totalStep,
            previousStepName: null,
            nextStepName: CreationStepName.COMPLETION_EXPERIENCE,
            group: ProfileCreationStepGroup.COMPLETION,
            component: LinkedInImportStep,
            trackingName: MaltClassicStepTrackingName.COMPLETION_LINKEDIN,
        },
        {
            name: CreationStepName.COMPLETION_EXPERIENCE,
            route: MaltClassicCreationStepRoute.COMPLETION_EXPERIENCE,
            stepNumber: decrementIfNeeded(MaltClassicCreationStepNumber.COMPLETION_EXPERIENCE),
            stepCount: totalStep,
            previousStepName: CreationStepName.COMPLETION_LINKEDIN,
            nextStepName: CreationStepName.COMPLETION_EDUCATION,
            group: ProfileCreationStepGroup.COMPLETION,
            component: YourExperienceStep,
            trackingName: MaltClassicStepTrackingName.COMPLETION_EXPERIENCE,
        },
        {
            name: CreationStepName.COMPLETION_EDUCATION,
            route: MaltClassicCreationStepRoute.COMPLETION_EDUCATION,
            stepNumber: decrementIfNeeded(MaltClassicCreationStepNumber.COMPLETION_EDUCATION),
            stepCount: totalStep,
            previousStepName: CreationStepName.COMPLETION_EXPERIENCE,
            nextStepName: CreationStepName.COMPLETION_DESCRIPTION,
            group: ProfileCreationStepGroup.COMPLETION,
            component: YourEducationStep,
            trackingName: MaltClassicStepTrackingName.COMPLETION_EDUCATION,
        },
        {
            name: CreationStepName.COMPLETION_DESCRIPTION,
            route: MaltClassicCreationStepRoute.COMPLETION_DESCRIPTION,
            stepNumber: decrementIfNeeded(MaltClassicCreationStepNumber.COMPLETION_DESCRIPTION),
            stepCount: totalStep,
            previousStepName: CreationStepName.COMPLETION_EDUCATION,
            nextStepName: CreationStepName.COMPLETION_RECOMMENDATION,
            group: ProfileCreationStepGroup.COMPLETION,
            component: DescriptionStep,
            trackingName: MaltClassicStepTrackingName.COMPLETION_DESCRIPTION,
        },
        {
            name: CreationStepName.COMPLETION_RECOMMENDATION,
            route: MaltClassicCreationStepRoute.COMPLETION_RECOMMENDATION,
            stepNumber: decrementIfNeeded(MaltClassicCreationStepNumber.COMPLETION_RECOMMENDATION),
            stepCount: totalStep,
            previousStepName: CreationStepName.COMPLETION_DESCRIPTION,
            nextStepName: CreationStepName.COMPLETION_PRIVACY,
            group: ProfileCreationStepGroup.COMPLETION,
            component: RecommendationStep,
            trackingName: MaltClassicStepTrackingName.COMPLETION_RECOMMENDATION,
        },
        {
            name: CreationStepName.COMPLETION_PRIVACY,
            route: MaltClassicCreationStepRoute.COMPLETION_PRIVACY,
            stepNumber: decrementIfNeeded(MaltClassicCreationStepNumber.COMPLETION_PRIVACY),
            stepCount: totalStep,
            previousStepName: CreationStepName.COMPLETION_RECOMMENDATION,
            nextStepName: null, // profile page
            group: ProfileCreationStepGroup.COMPLETION,
            component: PrivacyStep,
            trackingName: MaltClassicStepTrackingName.COMPLETION_PRIVACY,
        },
    ].filter(isNotNull);
}

function isNotNull<T>(item: T | null): item is T {
    return item !== null;
}
